<template>
  <v-footer class="pa-3">
    Developed By&nbsp;
    <v-icon small color="red">fas fa-heart</v-icon>Abhimanyu Kushwaha
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>